module.exports = __webpack_public_path__ + "img/icon-device-smartwatch.fea1e76f.svg";